import { ShimmerEffect } from "@/design-system/Atoms";

const NotificationTabShimmer = () => {
    return (
        <div className="flex flex-col h-[66vh] rounded-2xl backdrop-blur-md bg-white p-6 relative">
            <div className="flex justify-between items-center mb-6">
                <ShimmerEffect className="h-[32px] w-[32px] me-6" />
                <ShimmerEffect className="h-[60px] w-full" />
            </div>

            <div>
                <ShimmerEffect className="h-[72px] w-[93%] ms-13" />
            </div>

            <div className="flex justify-between items-center ms-13 gap-6 p-1 mt-4 mb-10">
                <ShimmerEffect className="h-[66px] w-full" />
                <ShimmerEffect className="h-[20px] w-full" />
            </div>

            <div className="flex justify-between items-center">
                <ShimmerEffect className="h-[32px] w-[32px] me-6" />
                <ShimmerEffect className="h-[60px] w-full" />
            </div>
        </div>
    );
};

export default NotificationTabShimmer;
